import { render, staticRenderFns } from "./caseEvidence.vue?vue&type=template&id=732c8b10&scoped=true"
import script from "./caseEvidence.vue?vue&type=script&lang=js"
export * from "./caseEvidence.vue?vue&type=script&lang=js"
import style0 from "./caseEvidence.vue?vue&type=style&index=0&id=732c8b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732c8b10",
  null
  
)

export default component.exports